import { render } from "./CoachClassFee.vue?vue&type=template&id=0eb84ac7"
import script from "./CoachClassFee.vue?vue&type=script&lang=js"
export * from "./CoachClassFee.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__